module.exports = __webpack_public_path__ + "img/img72.267020a0.png";